import React from 'react';
import Navbar from '@/components/Navbar';
import { useLanguage } from '@/contexts/LanguageContext';
import { Newspaper, Award, Target, Users } from 'lucide-react';

const AboutUs = () => {
  const { language } = useLanguage();

  const content = {
    kn: {
      pageTitle: 'ನಮ್ಮ ಬಗ್ಗೆ: ಚಿತ್ರದುರ್ಗದ ಅಚಲ ಧ್ವನಿ',
      welcomeText: 'ಚಿತ್ರದುರ್ಗದ ಹೆಮ್ಮೆಯ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಪ್ರಾದೇಶಿಕ ಕನ್ನಡ ದಿನಪತ್ರಿಕೆಯಾದ \'ಕಲ್ಲಿನ ಕೂಗು\' ಡಿಜಿಟಲ್ ಆವೃತ್ತಿಗೆ (ಇ-ಪೇಪರ್) ನಿಮಗೆ ಆತ್ಮೀಯ ಸ್ವಾಗತ.',
      intro: 'ಹಲವು ವರ್ಷಗಳಿಂದ ನಮ್ಮ ಜಿಲ್ಲೆಯ ನಿಖರ, ಪರಿಣಾಮಕಾರಿ ಮತ್ತು ಕ್ಷಿಪ್ರ ಸುದ್ದಿಯನ್ನು ಜನರಿಗೆ ತಲುಪಿಸುತ್ತಾ, ನಾವು ಸ್ಥಳೀಯ ಪತ್ರಿಕೋದ್ಯಮದ ನಾಡಿಮಿಡಿತವಾಗಿದ್ದೇವೆ. ಈಗ ನಮ್ಮ ಇ-ಪೇಪರ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಮೂಲಕ, ನಮ್ಮೂರಿನ ಸುದ್ದಿಯನ್ನು ನೀವು ಜಗತ್ತಿನ ಯಾವುದೇ ಮೂಲೆಯಲ್ಲಿದ್ದರೂ ನಿಮ್ಮ ಬೆರಳ ತುದಿಗೆ ತರುತ್ತಿದ್ದೇವೆ.',
      heritageTitle: 'ನಮ್ಮ ಪರಂಪರೆ ಮತ್ತು ಹೆಸರು',
      heritageText: 'ಚಿತ್ರದುರ್ಗವು ತನ್ನ ಅಜೇಯ \'ಕಲ್ಲಿನ ಕೋಟೆ\'ಗೆ ಐತಿಹಾಸಿಕವಾಗಿ ಪ್ರಸಿದ್ಧವಾಗಿದೆ. ನಮ್ಮೂರಿನ ಈ ಪರಂಪರೆ ಮತ್ತು ಬಲದಿಂದ ಪ್ರೇರಿತವಾಗಿ ನಮ್ಮ ಪತ್ರಿಕೆಗೆ \'ಕಲ್ಲಿನ ಕೂಗು\' ಎಂದು ಹೆಸರಿಡಲಾಗಿದೆ. ಅನ್ಯಾಯದ ವಿರುದ್ಧ ದೃಢವಾಗಿ ನಿಲ್ಲುವ ಮತ್ತು ಸಾಮಾನ್ಯ ಕನ್ನಡಿಗನ ನೈಜ ಧ್ವನಿಯಾಗಿ ಪ್ರತಿಧ್ವನಿಸುವ ನಮ್ಮ ಪತ್ರಿಕೋದ್ಯಮದ ಬದ್ಧತೆಯನ್ನು ಈ ಹೆಸರು ಪ್ರತಿಬಿಂಬಿಸುತ್ತದೆ.',
      leadershipTitle: 'ನಮ್ಮ ನಾಯಕತ್ವ',
      leadershipText1: '\'ಕಲ್ಲಿನ ಕೂಗು\' ಪತ್ರಿಕೆಯು ನಮ್ಮ ಪ್ರಧಾನ ಸಂಪಾದಕರಾದ ಶ್ರೀ ಪ್ರಕಾಶ್ ಮೂರ್ತಿ ಎಸ್. ಅವರ ದೃಷ್ಟಿಕೋನ ಮತ್ತು ರಾಜಿ ಮಾಡಿಕೊಳ್ಳದ ತತ್ವಗಳ ಮಾರ್ಗದರ್ಶನದಲ್ಲಿ ನಡೆಯುತ್ತಿದೆ.',
      leadershipText2: 'ನಮ್ಮ ಭಾಗದಲ್ಲಿ "ಎಚ್ಚರಿಕೆ ಪ್ರಕಾಶ್ ಮೂರ್ತಿ" ಎಂದೇ ಚಿರಪರಿಚಿತರಾಗಿರುವ ಇವರ ಹೆಸರು, ಪತ್ರಿಕೋದ್ಯಮದಲ್ಲಿ ಅವರ ನಿರ್ಭೀತ ಮತ್ತು ನಿಷ್ಪಕ್ಷಪಾತ ನಿಲುವನ್ನು ಸಾರುತ್ತದೆ. ಅವರ ನಾಯಕತ್ವದಲ್ಲಿ, ನಮ್ಮ ಪತ್ರಿಕೆಯು ಸಮಾಜದ ಜ್ವಲಂತ ಸಮಸ್ಯೆಗಳ ಬಗ್ಗೆ ಜನರಲ್ಲಿ ಅರಿವು (ಎಚ್ಚರಿಕೆ) ಮೂಡಿಸುವ, ಅಧಿಕಾರಿಗಳನ್ನು ಎಚ್ಚರಿಸುವ ಮತ್ತು ಸತ್ಯ-ಆಧಾರಿತ ದಿಟ್ಟ ವರದಿಗಾರಿಕೆಗೆ ಹೆಸರುವಾಸಿಯಾಗಿದೆ.',
      servicesTitle: 'ನಾವು ನಿಮಗೆ ಒದಗಿಸುವ ಸೇವೆಗಳು',
      servicesIntro: 'ನಮ್ಮ ದೈನಂದಿನ ಇ-ಪೇಪರ್ ಮೂಲಕ ಈ ಕೆಳಗಿನವುಗಳನ್ನು ನಿಮಗೆ ತಲುಪಿಸಲು ನಾವು ಬದ್ಧರಾಗಿದ್ದೇವೆ:',
      service1Title: 'ಸಮಗ್ರ ಸ್ಥಳೀಯ ವರದಿಗಾರಿಕೆ',
      service1Text: 'ಚಿತ್ರದುರ್ಗ ಮತ್ತು ಅದರ ಸುತ್ತಮುತ್ತಲಿನ ತಾಲೂಕುಗಳ ರಾಜಕೀಯ, ಅಭಿವೃದ್ಧಿ ಮತ್ತು ದೈನಂದಿನ ಆಗುಹೋಗುಗಳ ಆಳವಾದ ವರದಿ.',
      service2Title: 'ನಿರ್ಭೀತ ಸಂಪಾದಕೀಯ',
      service2Text: '\'ಎಚ್ಚರಿಕೆ\' ಪ್ರಕಾಶ್ ಮೂರ್ತಿ ಮತ್ತು ನಮ್ಮ ಅನುಭವಿ ಸಂಪಾದಕೀಯ ತಂಡವು ಸಿದ್ಧಪಡಿಸುವ ವಿಶ್ಲೇಷಣಾತ್ಮಕ ಅಂಕಣಗಳು ಮತ್ತು ಅಭಿಪ್ರಾಯಗಳು.',
      service3Title: 'ಸಾಂಸ್ಕೃತಿಕ ಪರಂಪರೆ',
      service3Text: 'ನಮ್ಮ ಭಾಗದ ಶ್ರೀಮಂತ ಇತಿಹಾಸ, ಕಲೆ ಮತ್ತು ಸಾಹಿತ್ಯದ ಆಚರಣೆ ಮತ್ತು ಪ್ರೋತ್ಸಾಹ.',
      service4Title: 'ಡಿಜಿಟಲ್ ಸೌಲಭ್ಯ',
      service4Text: 'ನಿಮ್ಮ ನೆಚ್ಚಿನ ಮುದ್ರಿತ ಪತ್ರಿಕೆಯ ಅದೇ ಓದುವ ಅನುಭವ, ಈಗ ನಿಮ್ಮ ಸ್ಮಾರ್ಟ್‌ಫೋನ್, ಟ್ಯಾಬ್ಲೆಟ್ ಅಥವಾ ಕಂಪ್ಯೂಟರ್‌ಗೆ ತಕ್ಕಂತೆ.',
      missionTitle: 'ನಮ್ಮ ಗುರಿ (ಧ್ಯೇಯ)',
      missionText: 'ಚಿತ್ರದುರ್ಗದ ಜಾಗೃತ ಕಣ್ಣು ಮತ್ತು ಕಿವಿಯಾಗಿ ಸೇವೆ ಸಲ್ಲಿಸುವುದು. ಡಿಜಿಟಲ್ ಯುಗದಲ್ಲಿ ಕನ್ನಡ ಪತ್ರಿಕೋದ್ಯಮದ ಅತ್ಯುನ್ನತ ಗುಣಮಟ್ಟವನ್ನು ಕಾಯ್ದುಕೊಳ್ಳುತ್ತಾ, ಸತ್ಯದ ಮೂಲಕ ನಮ್ಮ ಓದುಗರನ್ನು ಸಬಲೀಕರಣಗೊಳಿಸುವುದು ಮತ್ತು ಸಮಾಜದಲ್ಲಿ ಜಾಗೃತಿ ಮೂಡಿಸುವುದು ನಮ್ಮ ಗುರಿಯಾಗಿದೆ.',
      tagline: '"ಕಲ್ಲಿನ ಕೂಗು: ಸತ್ಯಕ್ಕಾಗಿ ದೃಢವಾಗಿ ನಿಂತಿದೆ, ಜನರ ಧ್ವನಿಯಾಗಿ ಮೊಳಗುತ್ತಿದೆ."',
      registrationTitle: 'ಅಧಿಕೃತ ನೋಂದಣಿ ವಿವರಗಳು',
      rniLabel: 'ಆರ್ ಎನ್ ಐ ಸಂಖ್ಯೆ',
      rniInfo: 'ಭಾರತದ ರಿಜಿಸ್ಟ್ರಾರ್ ಆಫ್ ನ್ಯೂಸ್‌ಪೇಪರ್ಸ್‌ನಲ್ಲಿ ನೋಂದಾಯಿತ',
      ctaLabel: 'ಸಿ.ಟಿ.ಎ ಸಂಖ್ಯೆ',
      ctaInfo: 'ಚಿತ್ರದುರ್ಗ ಪತ್ರಿಕೆ ವಿತರಣಾ ಪರವಾನಗಿ',
      contactTitle: 'ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ',
      whatsappLabel: 'ವಾಟ್ಸಾಪ್',
      emailLabel: 'ಇಮೇಲ್',
      officialText: 'ಅಧಿಕೃತವಾಗಿ ನೋಂದಾಯಿತ ಮತ್ತು ಮಾನ್ಯತೆ ಪಡೆದ ಪತ್ರಿಕೆ'
    },
    en: {
      pageTitle: 'About Us: The Unwavering Voice of Chitradurga',
      welcomeText: 'Welcome to the digital edition (e-paper) of \'Kallina Koogu\' (Voice of the Stone), Chitradurga\'s proud and trusted regional Kannada daily newspaper.',
      intro: 'For many years, we have been the pulse of local journalism, delivering accurate, impactful, and timely news to the people of our district. Now, through our e-paper platform, we bring our hometown news to your fingertips, wherever you are in the world.',
      heritageTitle: 'Our Heritage and Name',
      heritageText: 'Chitradurga is historically famous for its invincible stone fort (Kallina Kote). Inspired by this heritage and strength of our town, our newspaper is named \'Kallina Koogu\' (Voice of the Stone). This name reflects our journalistic commitment to standing firm against injustice and echoing as the genuine voice of the common Kannadiga.',
      leadershipTitle: 'Our Leadership',
      leadershipText1: '\'Kallina Koogu\' newspaper operates under the vision and uncompromising principles of our Chief Editor, Sri Prakash Murthy S.',
      leadershipText2: 'Known in our region as "Echarike Prakash Murthy," his name conveys his fearless and unbiased stance in journalism. Under his leadership, our newspaper is renowned for raising awareness (Echarike) among people about pressing social issues, alerting authorities, and truth-based bold reporting.',
      servicesTitle: 'Our Services',
      servicesIntro: 'Through our daily e-paper, we are committed to bringing you:',
      service1Title: 'Comprehensive Local Reporting',
      service1Text: 'In-depth coverage of politics, development, and daily happenings in Chitradurga and surrounding taluks.',
      service2Title: 'Fearless Editorials',
      service2Text: 'Analytical columns and opinions prepared by \'Echarike\' Prakash Murthy and our experienced editorial team.',
      service3Title: 'Cultural Heritage',
      service3Text: 'Celebration and promotion of our region\'s rich history, arts, and literature.',
      service4Title: 'Digital Convenience',
      service4Text: 'The same reading experience of your favorite print newspaper, now tailored for your smartphone, tablet, or computer.',
      missionTitle: 'Our Mission',
      missionText: 'To serve as the vigilant eye and ear of Chitradurga. Our goal is to empower our readers through truth and raise awareness in society while maintaining the highest standards of Kannada journalism in the digital age.',
      tagline: '"Kallina Koogu: Standing Firm for Truth, Resonating as the People\'s Voice."',
      registrationTitle: 'Official Registration Details',
      rniLabel: 'RNI Number',
      rniInfo: 'Registered with the Registrar of Newspapers for India',
      ctaLabel: 'CTA Number',
      ctaInfo: 'Chitradurga Newspaper Distribution License',
      contactTitle: 'Contact Us',
      whatsappLabel: 'WhatsApp',
      emailLabel: 'Email',
      officialText: 'Officially Registered and Recognized Newspaper'
    }
  };

  const text = content[language];

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />

      {/* Hero Section */}
      <div className="relative bg-[#1E293B] text-white py-8 sm:py-12 md:py-16">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center space-y-3 sm:space-y-4 md:space-y-6">
            <h1 
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight px-2"
              style={{ fontFamily: 'Noto Serif Kannada, Playfair Display, serif' }}
              data-testid="about-page-title"
            >
              {language === 'kn' ? 'ನಮ್ಮ ಬಗ್ಗೆ' : 'About Us'}
            </h1>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto px-4">
              {text.welcomeText}
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 md:px-6 py-12">
        <div className="max-w-4xl mx-auto space-y-12">
          
          {/* Introduction */}
          <section className="bg-white rounded-lg shadow-md p-6 md:p-8 paper-texture">
            <p className="text-lg leading-relaxed text-gray-700" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
              {text.intro}
            </p>
          </section>

          {/* Heritage Section */}
          <section className="bg-white rounded-lg shadow-md p-6 md:p-8">
            <div className="flex items-start space-x-4 mb-4">
              <div className="bg-[#B91C1C] p-3 rounded-lg">
                <Newspaper className="h-6 w-6 text-white" />
              </div>
              <h2 
                className="text-2xl md:text-3xl font-bold text-[#1E293B]"
                style={{ fontFamily: 'Noto Serif Kannada, Playfair Display, serif' }}
              >
                {text.heritageTitle}
              </h2>
            </div>
            <p className="text-lg leading-relaxed text-gray-700" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
              {text.heritageText}
            </p>
          </section>

          {/* Leadership Section */}
          <section className="bg-white rounded-lg shadow-md p-6 md:p-8">
            <div className="flex items-start space-x-4 mb-4">
              <div className="bg-[#B91C1C] p-3 rounded-lg">
                <Users className="h-6 w-6 text-white" />
              </div>
              <h2 
                className="text-2xl md:text-3xl font-bold text-[#1E293B]"
                style={{ fontFamily: 'Noto Serif Kannada, Playfair Display, serif' }}
              >
                {text.leadershipTitle}
              </h2>
            </div>
            <div className="space-y-4">
              <p className="text-lg leading-relaxed text-gray-700" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                {text.leadershipText1}
              </p>
              <p className="text-lg leading-relaxed text-gray-700" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                {text.leadershipText2}
              </p>
            </div>
          </section>

          {/* Services Section */}
          <section className="bg-white rounded-lg shadow-md p-6 md:p-8">
            <div className="flex items-start space-x-4 mb-6">
              <div className="bg-[#B91C1C] p-3 rounded-lg">
                <Award className="h-6 w-6 text-white" />
              </div>
              <h2 
                className="text-2xl md:text-3xl font-bold text-[#1E293B]"
                style={{ fontFamily: 'Noto Serif Kannada, Playfair Display, serif' }}
              >
                {text.servicesTitle}
              </h2>
            </div>
            <p className="text-lg leading-relaxed text-gray-700 mb-6" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
              {text.servicesIntro}
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Service 1 */}
              <div className="bg-[#FFFCF5] p-6 rounded-lg border border-gray-200">
                <h3 className="text-xl font-semibold text-[#B91C1C] mb-2" style={{ fontFamily: 'Noto Serif Kannada, serif' }}>
                  {text.service1Title}
                </h3>
                <p className="text-gray-700 leading-relaxed" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                  {text.service1Text}
                </p>
              </div>

              {/* Service 2 */}
              <div className="bg-[#FFFCF5] p-6 rounded-lg border border-gray-200">
                <h3 className="text-xl font-semibold text-[#B91C1C] mb-2" style={{ fontFamily: 'Noto Serif Kannada, serif' }}>
                  {text.service2Title}
                </h3>
                <p className="text-gray-700 leading-relaxed" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                  {text.service2Text}
                </p>
              </div>

              {/* Service 3 */}
              <div className="bg-[#FFFCF5] p-6 rounded-lg border border-gray-200">
                <h3 className="text-xl font-semibold text-[#B91C1C] mb-2" style={{ fontFamily: 'Noto Serif Kannada, serif' }}>
                  {text.service3Title}
                </h3>
                <p className="text-gray-700 leading-relaxed" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                  {text.service3Text}
                </p>
              </div>

              {/* Service 4 */}
              <div className="bg-[#FFFCF5] p-6 rounded-lg border border-gray-200">
                <h3 className="text-xl font-semibold text-[#B91C1C] mb-2" style={{ fontFamily: 'Noto Serif Kannada, serif' }}>
                  {text.service4Title}
                </h3>
                <p className="text-gray-700 leading-relaxed" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                  {text.service4Text}
                </p>
              </div>
            </div>
          </section>

          {/* Mission Section */}
          <section className="bg-white rounded-lg shadow-md p-6 md:p-8">
            <div className="flex items-start space-x-4 mb-4">
              <div className="bg-[#B91C1C] p-3 rounded-lg">
                <Target className="h-6 w-6 text-white" />
              </div>
              <h2 
                className="text-2xl md:text-3xl font-bold text-[#1E293B]"
                style={{ fontFamily: 'Noto Serif Kannada, Playfair Display, serif' }}
              >
                {text.missionTitle}
              </h2>
            </div>
            <p className="text-lg leading-relaxed text-gray-700 mb-6" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
              {text.missionText}
            </p>
            
            <div className="bg-[#B91C1C] text-white p-6 rounded-lg text-center">
              <p className="text-xl md:text-2xl font-bold leading-relaxed" style={{ fontFamily: 'Noto Serif Kannada, Playfair Display, serif' }}>
                {text.tagline}
              </p>
            </div>
          </section>

          {/* RNI Information */}
          <section className="bg-[#FFFCF5] rounded-lg border-2 border-[#B91C1C] p-6 md:p-8">
            <div className="flex items-center justify-center space-x-2 mb-6">
              <Award className="h-6 w-6 text-[#B91C1C]" />
              <h3 className="text-2xl font-bold text-[#1E293B]" style={{ fontFamily: 'Noto Serif Kannada, Playfair Display, serif' }}>
                {text.registrationTitle}
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              {/* RNI Number */}
              <div className="bg-white p-6 rounded-lg border-2 border-[#B91C1C] text-center">
                <p className="text-sm text-gray-600 mb-2" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                  {text.rniLabel}
                </p>
                <p className="text-2xl font-bold text-[#B91C1C] mb-2" style={{ fontFamily: 'monospace' }}>
                  KARKAN/2016/78276
                </p>
                <p className="text-xs text-gray-500" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                  {text.rniInfo}
                </p>
              </div>

              {/* CTA Number */}
              <div className="bg-white p-6 rounded-lg border-2 border-[#B91C1C] text-center">
                <p className="text-sm text-gray-600 mb-2" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                  {text.ctaLabel}
                </p>
                <p className="text-xl font-bold text-[#B91C1C] mb-2" style={{ fontFamily: 'monospace' }}>
                  KA/SK/CTA-853/2024-2026
                </p>
                <p className="text-xs text-gray-500" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                  {text.ctaInfo}
                </p>
              </div>
            </div>

            <p className="text-center text-sm text-gray-600" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
              {text.officialText}
            </p>
          </section>

          {/* Contact Information */}
          <section className="bg-white rounded-lg shadow-md p-6 md:p-8">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-[#1E293B] mb-2" style={{ fontFamily: 'Noto Serif Kannada, Playfair Display, serif' }}>
                {text.contactTitle}
              </h3>
              <p className="text-gray-600" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                {language === 'kn' ? 'ನಮ್ಮೊಂದಿಗೆ ಸಂಪರ್ಕದಲ್ಲಿರಿ' : 'Get in touch with us'}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* WhatsApp */}
              <div className="bg-[#FFFCF5] p-6 rounded-lg border border-gray-200">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="bg-[#25D366] p-2 rounded-full">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                    </svg>
                  </div>
                  <h4 className="font-bold text-[#1E293B]" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                    {text.whatsappLabel}
                  </h4>
                </div>
                <a href="https://wa.me/919481916130" target="_blank" rel="noopener noreferrer" className="block text-[#B91C1C] hover:text-[#991B1B] font-semibold mb-2" style={{ fontFamily: 'monospace' }}>
                  +91 9481916130
                </a>
                <a href="https://wa.me/917019362261" target="_blank" rel="noopener noreferrer" className="block text-[#B91C1C] hover:text-[#991B1B] font-semibold" style={{ fontFamily: 'monospace' }}>
                  +91 7019362261
                </a>
              </div>

              {/* Email */}
              <div className="bg-[#FFFCF5] p-6 rounded-lg border border-gray-200">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="bg-[#B91C1C] p-2 rounded-full">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-[#1E293B]" style={{ fontFamily: 'Noto Sans Kannada, Inter, sans-serif' }}>
                    {text.emailLabel}
                  </h4>
                </div>
                <a href="mailto:kallinakoogu@gmail.com" className="text-[#B91C1C] hover:text-[#991B1B] font-semibold break-all" style={{ fontFamily: 'monospace' }}>
                  kallinakoogu@gmail.com
                </a>
              </div>
            </div>
          </section>

        </div>
      </div>

      
    </div>
  );
};

export default AboutUs;
